import {Crumbs} from "../Crumbs.jsx";
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import {CardActions, CardHeader, Divider} from "@mui/material";
import CardContent from "@mui/material/CardContent";
import {OriginalCalendarButton} from "../Button/OriginalCalendarButton.jsx";
import {DailyCalendarButton} from "../Button/DailyCalendarButton.jsx";
import {OutOfTownButton} from "../Button/OutOfTownButton.jsx";
import {InTownButton} from "../Button/InTownButton.jsx";
import {Helmet} from "react-helmet";
import VenueCard from "../VenueCard.jsx";
import {Typography} from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

const desc = "Multiple calendars and a list of dance friendly venues"
const title = "Where to dance 2-step in Austin"
const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;

export const WhereToDancePage = () => {
    const [coreVenues, setCoreVenues] = useState([]);

    useEffect(() => {
        const fetchCoreVenues = async () => {
            try {
                const res = await fetch(
                    `${BACKEND_HOST}/venues?filters[core][$eq]=true&sort=name:asc&populate=images`
                );
                const data = await res.json();
                setCoreVenues(data.data || []);
            } catch (e) {
                setCoreVenues([]);
            }
        };
        fetchCoreVenues();
    }, []);

    return <Grid container spacing={1}>
        <Grid item xs={12}>
            <Helmet>
                <meta charSet="utf-8"/>
                <meta property="og:description" content={desc}/>
                <meta property="twitter:title" content={title}/>
                <meta property="twitter:description" content={desc}/>
                <title>{title}</title>
                <meta property="description" content={desc} />
                <link rel="canonical" href="https://austin2step.com/twostep-lessons"/>
            </Helmet>
            <Crumbs crumbs={
                [
                    {title: "Where To Dance"}
                ]} />
        </Grid>
        <Grid item xs={12} md={6}>
            <Box style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center"}} gap={1}>
                <Box style={{textAlign: "center", width: "100%",display: "flex", flexDirection: "column", alignItems: "center"}}>
                    <OriginalCalendarButton fullWidth />
                    <Typography color="text.secondary" variant="body2">6 week view, simplified</Typography>
                </Box>
                <Box style={{width: "100%", display: "flex", flexDirection: "column", alignItems: "center"}}>
                    <DailyCalendarButton fullWidth />
                    <Box><Typography color="text.secondary" variant="body2">Daily view, detailed</Typography></Box>
                </Box>
            </Box>
        </Grid>
    
        <Grid item xs={12} md={6}>
            <Box style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center"}} gap={1}>
                <Box style={{display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center"}} p={1}>
                    <InTownButton />
                    <Box sx={{textAlign: "center"}}><Typography color="text.secondary" variant="body2">Searchable local venues</Typography></Box>
                </Box>
                <Box style={{display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center"}} p={1}>
                    <OutOfTownButton />
                    <Box sx={{textAlign: "center"}}><Typography color="text.secondary" variant="body2">Dancer favorites while traveling</Typography></Box>
                </Box>
            </Box>
        </Grid>
        <Grid item xs={12}>
            <Box style={{display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "center"}} mb={1}>
                <Typography variant="h5">Favorite Honky Tonks</Typography>
                <Typography variant="body2" color="text.secondary">Discover the best honky tonks in Austin for 2-step dancing. When these places are on the calendar, you will almost always find dancers.</Typography>
            </Box>
        </Grid>
        {/* Example: Display core venues with images */}
        {coreVenues.length > 0 ? (
                coreVenues.map((venue) => (
                    <Grid item key={venue.venueKey} xs={12} sm={6} md={4}>
                        <VenueCard venue={venue} showCityState={true} />
                    </Grid>
                ))
            ) : (
                <Grid item xs={12} key={0}>
                    <Typography variant="body1" color="text.secondary" align="center">
                        No venues found matching your criteria.
                    </Typography>
                </Grid>
        )}
    </Grid>
}